export const resetScroll = () => {
  const desktopScroller = document.getElementById("scrollContainer");
  if (desktopScroller) desktopScroller?.scrollTo?.(0, 0);
  if (window !== undefined) window.scrollTo(0, 0);
};
